<script setup lang="ts">
defineProps<{
  label: string;
  color?: string;
}>();
</script>

<template>
  <span class="role-badge" :style="{ backgroundColor: `${color ?? '#db2777'}22`, color: color ?? '#db2777' }">
    {{ label }}
  </span>
</template>

<style scoped>
.role-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
</style>
